import styled from 'styled-components';

export const SectionInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const ItemWrapper = styled.div<{ $isSelected: boolean }>`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  border-radius: 8px;
  border: 1px solid
    ${({ theme, $isSelected }) => ($isSelected ? theme.colors.green6 : theme.colors.black4)};
  background: ${({ theme, $isSelected }) =>
    $isSelected ? theme.colors.green1 : theme.colors.white};
  cursor: pointer;
  width: 100%;

  &:hover {
    background: ${({ theme }) => theme.colors.green1};
    border: 1px solid ${({ theme }) => theme.colors.green6};
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.colors.green6};
    border-color: ${({ theme }) => theme.colors.green6};
  }
`;

export const TextWrapper = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  flex: 1 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PracticeCountWrapper = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
